const phoneRegex = /^1[3-9]\d{9}$/

const verifyPhone = (phone) => {
    return phoneRegex.test(phone)
}
export default verifyPhone
